import Icon from "../../../../../components/ui/icons/Icon";
import iconsList from "../../../../../components/ui/icons/iconsList";
import classes from './DownloadImg.module.css';

export const DownloadImg = ({ img }) => {

    const handleDownloadImage = async (url, alt) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `${alt || "image"}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        }
        catch (error) {
            console.error("Download failed:", error);
        }
    };

    return (
        <div className={classes.frameWrapper}>
            <div className={classes.frameTopBar}>
                <Icon name={iconsList.threeDots} className={classes.threeDots} />
            </div>
            <div className={classes.frameContent} onClick={() => handleDownloadImage(img?.url, img?.alt)}>
                <img src={img?.url} alt={img?.alt} className={classes.previewImage} />
                <Icon name={iconsList.download} className={classes.downloadIcon} />
                <div className={classes.sideIcons}>
                    <Icon name={iconsList.camera} className={classes.sideIcon} />
                    <Icon name={iconsList.check} className={classes.sideIcon} />
                    <Icon name={iconsList.star} className={classes.sideIcon} />
                </div>
            </div>
        </div>
    );
};
export default DownloadImg;
